import {
  Center,
  Container,
  Heading,
  Input,
  SimpleGrid,
  Spinner,
  useColorMode,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

import FeaturedCard from "@/components/FeaturedCard";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";

export default function Search() {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { colorMode } = useColorMode();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      setLoading(true);
      const url =
        "https://api.songcards.io/feat-cards-search/?search=" +
        debouncedSearchTerm;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          setSearchResults(data);
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
          setError(error);
        })
        .finally(() => setLoading(false));
    } else {
      setSearchResults([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <>
      <Head>
        <title>Songcards - Search</title>
        <meta
          name="description"
          content="Search songcards by artist, song, or genre."
        />
        <link rel="icon" href="/SC Icon_A_Light.svg" />
        <meta property="og:title" content="Songcards - Search" key="title" />
        <meta
          property="og:description"
          content="Search songcards by artist, song, or genre."
          key="description"
        />
      </Head>
      <Container>
        <Heading ml={1}>Search</Heading>
        <br />
        <Input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by artist, song, or genre..."
          colorScheme="pink"
          variant={"outline"}
          focusBorderColor="rgba(255,153,213,0.9)"
        />
        <br />
        <br />
        {loading && (
          <Center>
            <Spinner size="xl" color="rgba(255,153,213,0.9)" />
          </Center>
        )}
      </Container>
      <Container maxW="2xl" p={4}>
        <SimpleGrid columns={[1, null, 2]} spacing="25px">
          {searchResults.map((item, index) => (
            <FeaturedCard embed={false} item={item} key={index} />
          ))}
        </SimpleGrid>
        {searchResults.length > 0 && (
          <Center mb={300} mt={100}>
            <Link href={`/`}>
              <Image
                src={
                  colorMode === "dark"
                    ? "/SC Icon_B_White.svg"
                    : "/SC Icon_B_Black.svg"
                }
                width={30}
                alt="Discover more Songcards"
                height={30}
              />
            </Link>
          </Center>
        )}
      </Container>
    </>
  );
}
